// 💋 Embrasser — bisou volé : l'adversaire attend sans bouger, puis disparaît et réapparaît ailleurs,
// à mi-distance du joueur. Il s'efface en fondu doux juste avant de partir (`blink`, voir ui/renderer.js).
import { baseState, countTick, distanceMap, finish, pickCell, sameCell, timeGain } from './common.js';

export const BLINK_TICKS = 2;

/**
 * Nouvelle cachette : à une distance du joueur entre 30 et 55 % du chemin, jamais la cachette
 * actuelle (`avoid`), sinon la plus lointaine possible.
 */
export function hideout(grid, player, length, random, avoid = null) {
  const dist = distanceMap(grid, player);
  const min = Math.max(2, Math.ceil(length * 0.3));
  const max = Math.max(min, Math.ceil(length * 0.55));
  const cells = [];
  let farthest = { x: player.x, y: player.y };
  dist.forEach((row, y) => row.forEach((d, x) => {
    if (d >= min && d <= max && !sameCell({ x, y }, avoid)) cells.push({ x, y });
    if (d > dist[farthest.y][farthest.x]) farthest = { x, y };
  }));
  return cells.length > 0 ? pickCell(cells, random) : farthest;
}

function teleport(state, grid, player, random) {
  const rival = hideout(grid, player, state.length, random, state.rival);
  return { ...state, rival, trail: [rival], heading: 0, countdown: state.period, blink: false };
}

export const kiss = {
  id: 'kiss',
  create(ctx) {
    const length = Math.max(1, ctx.path.length - 1);
    const period = Math.max(4, Math.ceil(length * 0.3) + 2);
    const state = baseState(ctx, { rival: ctx.path.at(-1), budget: period * 4, idleTicks: Math.ceil(period / 2), length, period, countdown: period });
    return teleport(state, ctx.grid, ctx.player, ctx.random ?? Math.random);
  },
  tick(state, { grid, player, random = Math.random }) {
    let next = countTick(state);
    if (next.result) return next;
    const countdown = next.countdown - 1;
    next = countdown <= 0 ? teleport(next, grid, player, random) : { ...next, countdown, blink: countdown <= BLINK_TICKS };
    return sameCell(next.rival, player) ? finish(next, 'win') : next;
  },
  enter: (state, { player }) => (sameCell(state.rival, player) ? finish(state, 'win') : state),
  gain: (state) => timeGain(state.fullGain, state.ticks, state.budget),
  isIdle: (state) => state.ticks >= state.idleTicks,
  hints: (state) => [{ key: 'scenario.kiss.hint.rival', cell: state.rival }],
};
